module.exports = __webpack_public_path__ + "img/ic-ic-now-pig.1530c7c9.svg";